module.exports = {
  fixTelephoneLink: (value) => {
    return value
      .replace(/^tel:\/\//, 'tel:')
      .replace(/^https:\/\/tel:/, 'tel:')
      .replace(/^http:\/\/tel:/, 'tel:');
  },
};
